import { ReactNode } from 'react';
import { Alert as NativeAlert } from '@mantine/core';
import classes from './Alert.module.css';

export const Alert = (props: {
	children?: ReactNode;
	variant: string;
	color: string;
	title: string;
}) => {
	return (
		<NativeAlert
			classNames={classes}
			{...props}
		></NativeAlert>
	);
};
